<section id="sensor-failures-audit-grid" *ngIf="visible">
  <p-table stripedRows  #dt sortField="created_date" [sortOrder]="-1" [columns]="selectedCols" [value]="rows" [paginator]="true"
    [rows]="rowsPerPage"  [scrollable]="true" selectionMode="none"
    exportFilename="aqmesh-sensor-failures-reported"
    styleClass="p-datatable-lg  p-datatable-gridlines" [resizableColumns]="true"
    stateStorage="local" stateKey="sensor_fail_audit">
    <ng-template pTemplate="caption">
      <div class="p-col-12">
        <button type="button" pButton icon="fas fa-th" class="p-button-success" (click)="exportCSV()"
          positionStyle="fixed" pTooltip="Export to CSV, for best results please set your spreadsheet to auto-import comma separated data files"
          tooltipEvent="hover" tooltipPosition="top" showDelay="500" hideDelay="500"></button>
        <div class="fr">
          <label *ngIf="dt.totalRecords !== (rows?.length ? rows?.length : 0)" tooltipEvent="hover" showDelay="500"
            hideDelay="500" positionStyle="fixed" pTooltip="Number of filtered records" class="row-count"><span
              class="p-col-12">{{dt.totalRecords}}</span></label>
          <p-select ngDefaultControl [options]="rowsPerPageOptions" [(ngModel)]="rowsPerPage" tooltipEvent="hover" showDelay="500"
            hideDelay="500" positionStyle="fixed" pTooltip="Number of records display per page" styleClass="row-options"
            (onChange)="setPreferences()">
          </p-select>
          <label>|</label>
          <label tooltipEvent="hover" showDelay="500" hideDelay="500" positionStyle="fixed" pTooltip="Total number of records"
            class="row-count">{{(rows?.length ? rows?.length : 0)}}</label>
          <label *ngIf="dt.totalRecords !== (rows?.length ? rows?.length : 0)" class="pageCountSeperator">of</label>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="colgroup" let-columns>
      <colgroup>
        <col *ngFor="let col of columns"  />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" pResizableColumn [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <ng-container *ngFor="let col of columns" [ngSwitch]="col.isReadonly">
          <ng-container *ngSwitchCase="false">
            <td [class]="col.datatype" [ngClass]="{'bg-is-dirty': rowData['isDirty']}" pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input ngDefaultControl type="text" [(ngModel)]="rowData[col.field]" [ngModelOptions]="{standalone: true}"
                    [maxlength]="col.maxLength === 0 ? 50 : col.maxLength" [required]="col.isRequired" pInputText
                    (change)="setDirty(rowData, col.field)">
                </ng-template>
                <ng-template pTemplate="output">
                  <ng-container [ngSwitch]="col.datatype">
                    <span class="fr" *ngSwitchCase="'decimal'">{{rowData[col.field]| number:'1.4-4'}}</span>
                    <span *ngSwitchCase="'Date'">{{rowData[col.field] | date:'dd-MMM-yyyy HH:mm'}}</span>
                    <span *ngSwitchDefault>{{rowData[col.field]}}</span>
                  </ng-container>
                </ng-template>
              </p-cellEditor>
            </td>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <td [class]="col.datatype" [ngSwitch]="col.datatype"
              [ngClass]="{ 'bg-grey-dark fg-white': col.isReadonly === true}">
              <span class="fr" *ngSwitchCase="'decimal'">{{rowData[col.field]| number:'1.4-4'}}</span>
              <span *ngSwitchCase="'Date'">{{rowData[col.field] | date:'dd-MMM-yyyy HH:mm'}}</span>
              <p-checkbox ngDefaultControl *ngSwitchCase="'boolean'" [(ngModel)]="rowData[col.field]"
                [ngModelOptions]="{standalone: true}" binary="true" (onChange)="setCheckboxDirty(rowData, col.header)">
              </p-checkbox>
              <span *ngSwitchDefault>{{rowData[col.field]}}</span>
            </td>
          </ng-container>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</section>
